"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_responsive_1 = __importDefault(require("react-responsive"));
var WebMediaQuery = /** @class */ (function (_super) {
    __extends(WebMediaQuery, _super);
    function WebMediaQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebMediaQuery.prototype.render = function () {
        var _a = this.props, mobileOnly = _a.mobileOnly, desktopOnly = _a.desktopOnly, largeDesktopOnly = _a.largeDesktopOnly;
        var query = 'screen';
        if (largeDesktopOnly) {
            query = 'screen and (min-width : 1024px)';
        }
        if (desktopOnly) {
            query = 'screen and (min-width : 769px)';
        }
        if (mobileOnly) {
            query = 'screen and (max-width : 768px)';
        }
        return react_1.default.createElement(react_responsive_1.default, { query: query }, this.props.children);
    };
    return WebMediaQuery;
}(react_1.Component));
exports.default = WebMediaQuery;
//# sourceMappingURL=WebMediaQuery.js.map